import React from 'react'
import './banner.css'
const LARGE_NAME_FONTS = [
  "Playfair Display, serif",
  "Cinzel Decorative, serif",
];


const Theme3NoPhotoBanner = ({values}) => {

     const isLargeNameFont = LARGE_NAME_FONTS.includes(
  values?.nameFontStyle
); 


     const noPhotoGroomNameDisplay = () => {
    return (
      <h3
        className={`t3-preview-banner-name ${
        isLargeNameFont ? "t3-preview-banner-name--compact" : ""
      }`}
        style={{ fontFamily: values.nameFontStyle }}
      >
          {values.groomName || "Groom"}
      </h3>
    );
  };

   const noPhotoBrideNameDisplay = () => {
    return (
      <h3
         className={`t3-preview-banner-name ${
        isLargeNameFont ? "t3-preview-banner-name--compact" : ""
      }`}
        style={{ fontFamily: values.nameFontStyle }}
      >
        {values.brideName || "Bride"}
      </h3>
    );
  };

  return (
    <>
  <div className="t3-preview-decoration">
      
       <img
    src="/theme3-vover-page-frame.png"
    className="t3-preview-cover-top-frame"
    alt=""
  />

    <img
    src="/theme3-cover-page-asset.png"
    className="t3-preview-cover-pillar t3-preview-cover-pillar-left"
    alt=""
  />

  {/* Right pillar */}
  <img
    src="/theme3-cover-page-asset.png"
    className="t3-preview-cover-pillar t3-preview-cover-pillar-right"
    alt=""
  />

  </div>
  <div className="t3-preview-cover-details">
   <span className="t3-preview-no-photo-cover-content">
          We are honored to welcome you to the wedding ceremony of
        </span>
         <div className="t3-preview-cover-name-wrapper">
           {values.displayOrder==="groomFirst"?(
          <>
               {noPhotoGroomNameDisplay()}
                <span 
                   className={`t3-preview-banner-and ${
        isLargeNameFont ? "t3-preview-banner-and--compact" : ""
      }`}
                style={{ fontFamily: values.nameFontStyle }}>&</span>
                   {noPhotoBrideNameDisplay()}

          </>
         ):<>
    {noPhotoBrideNameDisplay()}
                <span  
                       className={`t3-preview-banner-and ${
        isLargeNameFont ? "t3-preview-banner-and--compact" : ""
      }`}
                  style={{ fontFamily: values.nameFontStyle }}>&</span>
                  {noPhotoGroomNameDisplay()}
         </>}

         </div>
            <div className="t3-preview-banner-hashtag">  
             {values.hashtag ? `#${values.hashtag}` : ""}
           </div>
  </div>
</>
  )
}

export default Theme3NoPhotoBanner